import { Action, createReducer, on } from '@ngrx/store';
import { SyncDataState } from './sync-data.state';
import { syncronizeAllDataAction, syncronizeAllDataSuccessAction, syncronizeAllDataErrorAction } from './sync-data.actions';

const initialState = new SyncDataState();

const reducer = createReducer(
  initialState,
  on(syncronizeAllDataAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    return newState;
  }),
  on(syncronizeAllDataSuccessAction, (state) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = null;
    return newState;
  }),
  on(syncronizeAllDataErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failure;
    return newState;
  })
);

export function syncDataReducer(state: SyncDataState | null, action: Action) {
  return reducer(state, action);
}
